import { render, staticRenderFns } from "./GoPagesV2Editor.vue?vue&type=template&id=6ab95e28"
import script from "./GoPagesV2Editor.vue?vue&type=script&lang=js"
export * from "./GoPagesV2Editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports